import axios from 'axios';

const tokenField = 'x-access-token';

/*  */
const createAxios = (props = {}) => {
  const { baseURL = process.env.VUE_APP_API_URL, headers = {} } = props;

  const result = axios.create({
    baseURL,
    headers,
  });

  return result;
};

/*  */
const apiDev = createAxios();

const setToken = token => {
  apiDev.defaults.headers.common[tokenField] = token;
  localStorage.setItem('token', token);
};

export { apiDev, setToken };
